import has from '@dojo/framework/core/has';
import { registry } from 'lcc-state';
import { setTitle } from './support/state';
import { QuizFolder } from './widgets/quizfolder';
import { TopicQuestionFeedback } from './progressions/questionfeedback/topic';
import { PretestQuestionFeedback } from './progressions/questionfeedback/pretest';
import { PosttestQuestionFeedback } from './progressions/questionfeedback/posttest';
import { DefaultQuestionFeedback } from './progressions/questionfeedback/default-refactor';
import { Prometric } from './progressions/prometric';
import { PrometricMPE } from './progressions/prometric-mpe';
import { PearsonVue } from './progressions/pearson-vue';
import { Flashcard } from './progressions/flashcard';
import { SingleStep } from './progressions/single-step';
import { MCSelector } from './questions/mc-selector';
import { NumericEntry } from './questions/numeric-entry';
import { Definition } from './questions/definition';
import { Discussion } from './questions/discussion';
import { Memo } from './questions/memo';
import { ModuleProgress } from './widgets/module-progress';
registry.define('quiz', QuizFolder);
registry.define('flashcard', Flashcard);
registry.define('pearson-vue', PearsonVue);
registry.define('prometric', Prometric);
registry.define('prometric-mpe', PrometricMPE);
registry.define('question-feedback-posttest', PosttestQuestionFeedback);
registry.define('question-feedback-pretest', PretestQuestionFeedback);
registry.define('question-feedback-topic', TopicQuestionFeedback);
registry.define('question-feedback', DefaultQuestionFeedback);
registry.define('singlestep', SingleStep);
registry.define('Definition', Definition);
registry.define('Discussion', Discussion);
registry.define('MCQuestion', MCSelector);
registry.define('NumericEntry', NumericEntry);
registry.define('MemoAssignment', Memo);
if (has('quiz-progress-chart')) {
    registry.define('QuizModuleProgress', ModuleProgress);
}
export { setTitle };
